import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import * as treatmentActions from '../../redux/treatments/actions'
import * as treatmentSelectors from '../../redux/treatments/selectors'
import TreatmentsList from '../../components/list/TreatmentsList'
import LoadingSpinner from '../../components/loadingSpinner'
import PatientSelectorContainer from '../patients/Selector'
import BorderedArea from '../../components/layout/BorderedArea'

const AllTreatmentsContainer = (props) => {
    const [patientFilterId, setPatientFilterId] = React.useState(null)

    const {
        dispatchGetAllInProgress,
    } = props

    React.useEffect(() => {
        dispatchGetAllInProgress({ page: 1, patientId: patientFilterId, append: false })
    }, [dispatchGetAllInProgress, patientFilterId])

    const handlePatientFilterChange = (event) => {
        setPatientFilterId(event.target.value || null)
    }

    const handleLoadMore = () => {
        const { inProgressPagination } = props
        if (!inProgressPagination) return
        const nextPage = inProgressPagination.get('page') + 1
        dispatchGetAllInProgress({ page: nextPage, append: true })
    }

    const {
        allTreatmentsInProgress,
        treatmentsInProgressLoaded,
        inProgressPagination,
        inProgressLoading,
    } = props

    const patientFilterActive = !!patientFilterId
    const loadedCount = allTreatmentsInProgress ? allTreatmentsInProgress.count() : 0
    const total = inProgressPagination ? inProgressPagination.get('total') : loadedCount
    const hasMore = inProgressPagination ? inProgressPagination.get('hasMore') : false

    return (
        <div>
            <BorderedArea title='Filtrar'>
                <PatientSelectorContainer
                    handleChange={handlePatientFilterChange}
                    showViewButton={false}
                    showNewButton={false}
                    isClearable
                />
            </BorderedArea>
            {!treatmentsInProgressLoaded ? (
                <LoadingSpinner label='Cargando tratamientos...' />
            ) : loadedCount > 0 ? (
                <TreatmentsList
                    treatments={allTreatmentsInProgress}
                    loadedCount={loadedCount}
                    total={total}
                    showPatientChip={!patientFilterActive}
                    showLoadMore={hasMore && !patientFilterActive}
                    onLoadMore={handleLoadMore}
                    isLoadingMore={inProgressLoading}
                />
            ) : (
                <small>No se encontraron tratamientos.</small>
            )}
        </div>
    )
}

AllTreatmentsContainer.propTypes = {
    dispatchGetAllInProgress: PropTypes.func.isRequired,
    treatmentsInProgressLoaded: PropTypes.bool.isRequired,
    inProgressLoading: PropTypes.bool.isRequired,
    allTreatmentsInProgress: PropTypes.oneOfType([
        ImmutablePropTypes.map,
        PropTypes.oneOf([null]),
    ]),
    inProgressPagination: PropTypes.oneOfType([
        ImmutablePropTypes.map,
        PropTypes.oneOf([null]),
    ]),
}

const mapStateToProps = state => ({
    allTreatmentsInProgress: treatmentSelectors.getAllTreatmentsInProgress(state),
    treatmentsInProgressLoaded: treatmentSelectors.areAllTreatmentsInProgressLoaded(state),
    inProgressPagination: treatmentSelectors.getInProgressPagination(state),
    inProgressLoading: treatmentSelectors.isInProgressLoading(state),
})

const mapDispatchToProps = dispatch => ({
    dispatchGetAllInProgress: (options) => dispatch(treatmentActions.getAllInProgress(options)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AllTreatmentsContainer)
